import {Component, OnDestroy, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, ITEM_ID_TYPE} from "../../enums/enums";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";
import {ISearchItem} from "../../definitions";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";
import {PickService} from "../../services/pick.service";
import {Subject} from "rxjs/Subject";
import {JP} from "../../helpers/jp";
import {CollectionService} from "app/services/collection.service";


@Component({
  selector: 'app-quest-arc-page',
  templateUrl: './quest-arc-page.component.html',
  styles: []
})
export class QuestArcPageComponent implements OnInit, OnDestroy  {

  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Сюжетные арки");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.QUEST_ARCS)
    .setDefaultListLabels()
    .setItemLabelQuery('codeName')
    .setSearchParams(paramsHelper.search()
      .addParam('codeName', SEARCH_PROP_TYPES.STRING, "")
      .addNumberParam("id"));

  document: IDocument;
  quests: Array<ISearchItem> = [];

  private unsubscribe:Subject<void> = new Subject<void>();

  constructor(private busService: BusService,
              private pickService: PickService,
              private collectionService: CollectionService) {

  }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  createQuestLink(questId:number):string[] {
    var quest:ISearchItem = this.getSearchItem(questId);
    return createObjectLink(quest);
  }

  createQuestLinkQuery(questId:number):any {
    var quest:ISearchItem = this.getSearchItem(questId);
    return createObjectLinkQuery(quest);
  }

  getQuestName(questId:number):string {
    var quest:ISearchItem = this.getSearchItem(questId);
    return quest ? quest.codeName : 'NO NAME';// ? localeUtils.findName(quest): 'NO NAME' : "MISSING";
  }

  onAddQuestClick() {
    this.pickService.pickIdAndPushToArray(this.document, "/questsIds", ITEM_ID_TYPE.QUEST)
      .subscribe(result => {
        this.loadQuestsNames();
      });
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.document = e.document;

    if (this.document) {
      this.loadQuestsNames();
    }
  }

  private getSearchItem(id:number):ISearchItem
  {
    for (let i = 0; i < this.quests.length; i++)
    {
      if (this.quests[i].id == id)
      {
        return this.quests[i];
      }
    }
    return null;
  }

  private loadQuestsNames()
  {
    this.quests = [];
    const questsIds = JP.get(this.document, "/questsIds") || [];
    if (questsIds.length === 0) {
      return;
    }

    const searchParams = paramsHelper.search()
      .addParam("id", SEARCH_PROP_TYPES.ENUM_MULTI, questsIds)
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.QUESTS)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, _type: 1, category: 1, locales: 1, codeName:1})
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => {this.quests = r;});
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/quest-arc-page/quest-arc-page.component.ts